const IS_DEV =
    (window?.process?.env?.NODE_ENV ?? process.env.NODE_ENV) ===
        'development' ||
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) === 'local';
const IS_PROD =
    (window?.process?.env?.ENVIRONMENT ?? process.env.ENVIRONMENT) ===
    'production';

// Cache buster for translation JSON files to avoid stale CDN content.
const rawBuildTag =
    window?.process?.env?.BUILD_TAG ?? process.env.BUILD_TAG ?? '';
const translationCacheBuster =
    rawBuildTag && /^[\w.-]+$/.test(rawBuildTag)
        ? rawBuildTag
        : String(Date.now());

// Namespace names derived from local JSON files; requests for anything outside this set are suppressed.
const localNamespaces = new Set();

// try/catch lets webpack statically analyze require.context unconditionally
// while silently skipping it in non-webpack environments (e.g. tests).
try {
    require
        .context('./locales', true, /\.json$/)
        .keys()
        .forEach(filePath => {
            const match = filePath.match(/^\.\/[^/]+\/([^/]+)\.json$/);

            if (match) {
                localNamespaces.add(match[1]);
            }
        });
} catch (err) {
    if (!IS_PROD) {
        // eslint-disable-next-line no-console
        console.warn(
            '[i18n] Could not load locale namespaces via require.context:',
            err
        );
    }
}

const makeLoadPath = ns =>
    localNamespaces.has(ns)
        ? `/locales/{{lng}}/{{ns}}.json?v=${translationCacheBuster}`
        : 'data:application/json,%7B%7D';

export {localNamespaces, makeLoadPath, translationCacheBuster};

// i18n common config
export default {
    debug: IS_DEV,
    defaultNS: 'app',
    fallbackNS: 'common',
    ns: ['app', 'common'],
    backend: {
        // Repeated for both chained-backend slots: index 0 (localstorage in prod, HTTP in dev)
        // and index 1 (HTTP in prod); without both, the prod HTTP backend ignores makeLoadPath.
        backendOptions: Array(2).fill({
            loadPath: (_lngs, [ns]) => makeLoadPath(ns),
        }),
    },
};
